var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { useStore } from 'react-context-hook';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { BottomNav } from '@app/components/mol.track-bottom-nav';
import { axiosClient } from '@app/configure-app';
import { useStore as useS } from '@app/core/services';
import { useUserStore } from '@app/providers';
import { AppPath } from '@app/routes';
import { ActivityIndicator, Tab } from '@atomic';
import { ChallengeListV3, ChallengePhaseListV3 } from './components/challenges-v3';
import { BIBLIOTECA_ARQUIVOS_QUERY_KEY, BIBLIOTECA_ARQUIVOS_URL, FileLibrary, TITULO_BIBLIOTECA_ARQUIVOS, } from './components/file-library';
import { LibraryHeaderV3 } from './components/library-header-v3';
import { possuiRole, ROLE_DESAFIOS } from './course-library.utils';
export var CourseLibraryPage = function () {
    var _a, _b;
    var history = useHistory();
    var _c = useStore('currentLibraryCourse'), currentLibraryCourse = _c[0], setCurrentLibraryCourse = _c[1];
    var userData = useS(useUserStore).userData;
    // Desafios continuam dependendo da role; a Biblioteca de Arquivos só do compartilhamento (spec 4.2).
    var possuiDesafios = possuiRole(userData === null || userData === void 0 ? void 0 : userData.roles, ROLE_DESAFIOS);
    var _d = useQuery(BIBLIOTECA_ARQUIVOS_QUERY_KEY, function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, axiosClient.get(BIBLIOTECA_ARQUIVOS_URL)];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : []];
            }
        });
    }); }, { refetchOnWindowFocus: false }), _e = _d.data, biblioteca = _e === void 0 ? [] : _e, isLoading = _d.isLoading;
    var possuiArquivos = biblioteca.length > 0;
    var _f = React.useState('desafios'), abaEscolhida = _f[0], setAbaEscolhida = _f[1];
    var _g = React.useState([]), caminho = _g[0], setCaminho = _g[1];
    // Com só uma seção disponível, ela aparece sozinha (sem a barra de abas).
    var exibirAbas = possuiDesafios && possuiArquivos;
    var aba = !possuiDesafios ? 'arquivos' : !possuiArquivos ? 'desafios' : abaEscolhida;
    var titulo = aba === 'desafios'
        ? currentLibraryCourse
            ? "Fases -  " + currentLibraryCourse.nome
            : 'Desafios'
        : (_b = (_a = caminho[caminho.length - 1]) === null || _a === void 0 ? void 0 : _a.nome) !== null && _b !== void 0 ? _b : TITULO_BIBLIOTECA_ARQUIVOS;
    // O voltar da header sempre leva ao perfil; o curso aberto é limpo para a próxima visita abrir na lista.
    var handleVoltar = function () {
        setCurrentLibraryCourse(null);
        history.push(AppPath.PlayerProfile);
    };
    var renderDesafios = function () {
        return currentLibraryCourse ? React.createElement(ChallengePhaseListV3, { course: currentLibraryCourse }) : React.createElement(ChallengeListV3, null);
    };
    var renderArquivos = function () {
        return isLoading ? (React.createElement(ActivityIndicator, { type: "spinner" })) : (React.createElement(FileLibrary, { pastas: biblioteca, caminho: caminho, onAbrirPasta: function (pasta) { return setCaminho(__spreadArrays(caminho, [pasta])); }, onIrParaNivel: function (nivel) { return setCaminho(caminho.slice(0, nivel)); } }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LibraryHeaderV3, { title: titulo, onBack: handleVoltar }),
        exibirAbas && (React.createElement(Tab, { initialIndex: abaEscolhida === 'desafios' ? 0 : 1, onIndexChanged: function (index) { return setAbaEscolhida(index === 0 ? 'desafios' : 'arquivos'); } },
            React.createElement(Tab.Item, null, "Desafios"),
            React.createElement(Tab.Item, null, TITULO_BIBLIOTECA_ARQUIVOS))),
        aba === 'desafios' ? renderDesafios() : renderArquivos(),
        React.createElement(BottomNav, null)));
};
